const CONTACT_EMAIL_ADDRESS = 'getphy@sielbleu.org';
export default CONTACT_EMAIL_ADDRESS;
